import React, {useState} from 'react';
import {Dialog, DialogContent, Button, Stack, IconButton} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import axios from 'axios';
import CaseFileDeclined from "../../enums/CaseFileDeclined";
import CaseStatus from "../../enums/CaseStatus";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import TextField from "@mui/material/TextField";
import AdditionalDocumentEnum from "../../enums/AdditionalDocumentEnum";
import caseNotiFicationEnum from "../../enums/CaseNotiFicationEnum";

const UploadAdditionalFiles = ({onFileAdded, onCaseStatusChange, additionalFiles}) => {
    const [open, setOpen] = useState(false);
    const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
    const [files, setFiles] = useState([]);
    const [fileNames, setFileNames] = useState([]);
    const filesToUpdate = additionalFiles.filter(file => file.isRequestedAdditionalDocument === AdditionalDocumentEnum.AcceptedAdding)

    const sendNotification = async (caseId) => {
        try {
            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/CreateCaseNotificationforHeadOfAgency`, {
                caseId: caseId,
                caseStatus: CaseStatus.Sent.id,
                action: caseNotiFicationEnum.additionalDocs.id
            });

        } catch (error) {
        }
    };


    const handleOpenConfirmationModal = () => {
        setIsConfirmationModalOpen(true);
    };

    const handleCloseConfirmationModal = () => {
        setIsConfirmationModalOpen(false);
    };

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        resetFile();
    };

    const handleFileChange = (event) => {
        const selectedFiles = event.target.files;
        const updatedFiles = [...files];
        const updatedFileNames = [...fileNames];

        Array.from(selectedFiles).forEach(file => {
            updatedFiles.push(file);
            updatedFileNames.push(file.name);
        });

        setFiles(updatedFiles);
        setFileNames(updatedFileNames);
    };

    const updateFileStatus = async (filesToUpdate) => {
        try {
            await Promise.all(filesToUpdate.map(async (file) => {
                const updatedFile = {
                    ...file,
                    isRequestedAdditionalDocument: 0
                };

                await axios.put(`${process.env.REACT_APP_API_BASE_URL}/EditCaseFile`, updatedFile);
            }));

        } catch (error) {
        }
    };

    const handleSubmit = async () => {
        const urlParams = new URLSearchParams(window.location.search);
        const caseID = urlParams.get('id');

        for (const [index, file] of files.entries()) {
            const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/AddNewCaseFile`;
            const fileName = fileNames[index];
            const reader = new FileReader();

            reader.readAsDataURL(file);
            reader.onload = async () => {
                const base64File = reader.result.replace(/^data:.+;base64,/, '');
                const data = {
                    caseID: parseInt(caseID),
                    name: fileName,
                    ext: "pdf",
                    mainInfo: "",
                    additionalInfo: "",
                    file: base64File,
                    shared: true,
                    blank: false,
                    documentType: 0,
                    internal: false,
                    status: 3,
                    decline: CaseFileDeclined.No,
                    fileTypeId: 404,
                    declinedInternalStatus: 0
                };

                try {
                     await axios.post(apiUrl, data);

                    if (index === files.length - 1) {
                        await axios.post(`${process.env.REACT_APP_API_BASE_URL}/UpdateCaseStatusByUser`, {
                            caseId: parseInt(caseID),
                            caseStatus: CaseStatus.CaseCreatedWithFiles.id,
                        });

                        await sendNotification(parseInt(caseID))
                        if (filesToUpdate.length > 0) {
                            await updateFileStatus(filesToUpdate);
                        }
                        handleClose();
                        onCaseStatusChange();
                        onFileAdded();
                    }
                } catch (error) {
                }
            };
        }
    };


    const handleFileNameChange = (index, newName) => {
        const updatedFileNames = [...fileNames];
        updatedFileNames[index] = newName;
        setFileNames(updatedFileNames);
    };

    const handlePreview = (index) => {
        if (!files[index]) return;

        const file = files[index];
        const reader = new FileReader();

        reader.readAsDataURL(file);
        reader.onloadend = () => {
            const base64String = reader.result;

            const base64Content = base64String.split(',')[1];

            const binary = atob(base64Content);
            const byteNumbers = new Array(binary.length);

            for (let i = 0; i < binary.length; i++) {
                byteNumbers[i] = binary.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            const fileBlob = new Blob([byteArray], {type: 'application/pdf'});
            const fileURL = URL.createObjectURL(fileBlob);
            window.open(fileURL, '_blank');
        };
    };


    const resetFile = (index) => {
        const updatedFiles = [...files];
        const updatedFileNames = [...fileNames];
        updatedFiles.splice(index, 1);
        updatedFileNames.splice(index, 1);
        setFiles(updatedFiles);
        setFileNames(updatedFileNames);
    };
    return (
        <div>
            <button className={"document-buttonn"} onClick={handleClickOpen}>
                დამატებითი დოკუმენტაციის ატვირთვა
            </button>
            <Dialog style={{zIndex: 34}} fullWidth maxWidth="sm" open={open} onClose={handleClose}>
                <DialogContent>
                    <p></p>
                    <Stack direction="column" spacing={2}>
                        <input
                            accept="application/pdf"
                            style={{display: 'none'}}
                            id="contained-button-file"
                            type="file"
                            onChange={handleFileChange}
                        />
                        {fileNames.length === 0 && (
                            <label htmlFor="contained-button-file">
                                <Button fullWidth variant="contained" component="span">
                                    ფაილის დამატება
                                </Button>
                            </label>
                        )}


                        {fileNames.map((fileName, index) => (
                            <Stack key={index} direction="row" spacing={1} alignItems="center">
                                <TextField
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                    label="ფაილის სახელი"
                                    value={fileName}
                                    onChange={(e) => handleFileNameChange(index, e.target.value)}
                                />
                                <IconButton aria-label="preview" onClick={() => handlePreview(index)}>
                                    <VisibilityIcon/>
                                </IconButton>
                                <IconButton aria-label="delete" onClick={() => resetFile(index)}>
                                    <DeleteIcon/>
                                </IconButton>
                            </Stack>
                        ))}
                        <Button variant="contained" color="secondary" onClick={handleOpenConfirmationModal}
                                disabled={files.length === 0 }>
                            გაგზავნა
                        </Button>
                    </Stack>
                </DialogContent>
            </Dialog>
            <ConfirmationModal
                isOpen={isConfirmationModalOpen}
                onRequestClose={handleCloseConfirmationModal}
                onConfirm={handleSubmit}
            />
        </div>
    );
};

export default UploadAdditionalFiles;
